import React, { useState, useCallback } from 'react';
import {getStepFromPosition} from './getStepFromPosition.js';
import {getBarWidth} from './getBarWidth.js';
import {quantizeStep} from './quantizeStep.js';
import {DEFAULT_RESOLUTION} from './constants.js';
import { connect } from "react-redux";
import { setArrangementSelection } from "actions/index.js";
import { setArrangementRowSelections } from "actions/index.js";
import { setArrangementLoopSelected } from "actions/index.js";
import {NO_SUB_SEQUENCE} from 'session/constants.js';

const RIGHT = 'RIGHT';
const LEFT = 'LEFT';

function SelectionComponent(props) {
    if (props.selectionStart === undefined) {
        return '';
    }
     let style = {
        left: getBarWidth(props.selectionStart, props.resolution, props.xScale),
        width: getBarWidth(props.selectionEnd - props.selectionStart, props.resolution, props.xScale),
    };

    let className = "absolute-selection";
    if (props.loopSelected) {
        className += ' looping'
    }
    return (
        <div className={className} style={style}>
        </div>
    );       
}

function getSelectionStyle(props) {
    return {
        marginLeft: getBarWidth(props.selectionStart, props.resolution, props.xScale),
        width: getBarWidth(props.selectionEnd - props.selectionStart, props.resolution, props.xScale),
    };
}

const mapStateToProps = state => {
    let selection = state.arrangement.selection;
    return {
        selectionStart: selection !== undefined ? selection.start : undefined,
        selectionEnd: selection !== undefined ? selection.end : undefined,
        loopSelected: state.arrangement.loopSelected,
        resolution: DEFAULT_RESOLUTION,
        xScale: state.arrangement.xScale
    };
};

 const mapDispatchToProps = dispatch => {
    return {
        setArrangementRowSelections: (selections) => dispatch(setArrangementRowSelections(selections)),
        setArrangementSelection: (start, end) => dispatch(setArrangementSelection(start, end)),
        setArrangementLoopSelected: (selected) => dispatch(setArrangementLoopSelected(selected))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SelectionComponent);
